import {
  AuthFormBoxInternalTemplate,
  FIXED_INDENTS,
  PrimarySubmitButton,
  RememberMeWrapper,
} from '@setplex/arcana'
import { useForm } from 'effector-forms'
import { useUnit } from 'effector-react'
import type { JSX } from 'react'
import { type FormEvent } from 'react'
import { signInFx } from '../../model'
import { RememberMe } from '../../ui/RememberMe'
import { model as signInByEmailModel, translations } from '../model'
import { ForgotPasswordComponent } from './ForgotPasswordComponent'
import { LoginPasswordInputs } from './LoginPasswordInputs'

export interface SignInByEmailFormProps {
  forgotPasswordEnabled?: boolean
  rowGap?: FIXED_INDENTS[]
}

export const SignInByEmailForm = ({
  forgotPasswordEnabled,
  rowGap,
}: SignInByEmailFormProps): JSX.Element => {
  const formTranslations = useUnit(translations.$signInByEmailTranslations)

  const pending = useUnit(signInFx.pending)
  const { submit, eachValid } = useForm(signInByEmailModel.signInForm)

  const onSubmit = (e: FormEvent) => {
    e.preventDefault()
    submit()
  }

  return (
    <form onSubmit={onSubmit} noValidate>
      <AuthFormBoxInternalTemplate rowGap={rowGap}>
        <LoginPasswordInputs pending={pending} />
        <RememberMeWrapper>
          <RememberMe />
          {forgotPasswordEnabled && <ForgotPasswordComponent />}
        </RememberMeWrapper>
        <PrimarySubmitButton
          title={formTranslations.submitTitle}
          disabled={pending || !eachValid}
          isLoading={pending}
        />
      </AuthFormBoxInternalTemplate>
    </form>
  )
}
